import { get } from 'lodash';
import { INVERTED_METRIC_SWITCH_MAP } from '@utils/metrics';
import styles from './index.less';

export const CHART_KEY_PREFIX = 'chart-key-';
export const CHART_ID_PREFIX = 'chart-container-';
export const METRIC_CARD_PREFIX = 'metric-card-';

export const getSelectedChartId = (selectedMetric) => {
  const metricName = get(INVERTED_METRIC_SWITCH_MAP, selectedMetric, selectedMetric);
  const cleanedId = metricName.replace(/\W/g, '_');
  return `${CHART_ID_PREFIX}${cleanedId}`;
};

export function scrollChartToView(selectedMetric) {
  const chartId = getSelectedChartId(selectedMetric);
  const metricsContainerBody: any = document.querySelector(`.${styles.metricsContainerBody}`);
  const metricsCardToMove: any = document.querySelector(`#${chartId}`);
  if (metricsCardToMove) {
    metricsContainerBody.scrollTo({
      left: 0,
      top: metricsCardToMove.parentNode.parentNode.offsetTop,
      behavior: 'smooth',
    });
  }
}
